import axios from 'axios'
import { apiUrl } from '../config/env'
let headers = {
    'content-type': 'multipart/form-data'
}
const axiosIntance = axios.create({
    baseURL: apiUrl,
    headers: headers
})

axiosIntance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if(token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosIntance.interceptors.response.use(
    (response) => {
        return response;        
    }, 
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosIntance